import { LEGISLATION_REFERENCE_SET_HIGHLIGHTED } from './types'

export const legislationReferenceSetHighlighted = (highlighted: string[]): { type: typeof LEGISLATION_REFERENCE_SET_HIGHLIGHTED, highlighted: string[] } => ({
  type: LEGISLATION_REFERENCE_SET_HIGHLIGHTED,
  highlighted
})
